import React, { useState } from "react";
import { Paper, Typography, Divider, Grid, Chip, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ViewEmailAccount = ({ account }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (!account) {
    return null;
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const maskPassword = (password) => {
    if (!password) return "N/A";
    return "*".repeat(password.length);
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Email Account Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" color="primary">
            {account.name}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="textSecondary">
            <strong>Email Name:</strong>
          </Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {account.name}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="textSecondary">
            <strong>Status:</strong>
          </Typography>
          <Chip
            label={account.isActive ? "Active" : "Inactive"}
            color={account.isActive ? "success" : "default"}
            size="small"
            sx={{ mt: 0.5 }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary">
            <strong>Password:</strong>
          </Typography>
          <div style={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
            <Typography variant="body1" sx={{ mr: 1 }}>
              {showPassword ? account.password : maskPassword(account.password)}
            </Typography>
            <IconButton
              size="small"
              onClick={handleTogglePasswordVisibility}
              color="primary"
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewEmailAccount;